'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Utility = require('../../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _SimpleButton = require('../../generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _SpinButton = require('../../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _Api = require('../../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _MainStore = require('../../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _Actions = require('../../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Constants = require('../../Constants');

var Constants = _interopRequireWildcard(_Constants);

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SESSION_ERROR_MSG = "Your user session has expired! Please 'Sign Out' and 'Sign In.";
var ERROR_MESSAGE = "Some error occurred while placing order! Try Again!";

// define the stripe variable for initialization
var cardNumberElement = null;
var cardExpiryElement = null;
var cardCvcElement = null;
var cardPostalElement = null;
var stripe = null;

var AddCard = function (_React$Component) {
    _inherits(AddCard, _React$Component);

    function AddCard(props) {
        _classCallCheck(this, AddCard);

        var _this = _possibleConstructorReturn(this, (AddCard.__proto__ || Object.getPrototypeOf(AddCard)).call(this, props));

        _this.addPaymentMethodAndPlaceOrder = function () {

            var self = _this;
            var currentUser = _parse2.default.User.current();

            // billing details
            var billingDetails = {};

            // isLoggedInExistingUser= true when a user logged in
            // If a user clickecd on the create account checkbox
            if (!Utils.isEmptyObj(currentUser)) {
                billingDetails = {
                    name: currentUser.get("name"),
                    email: currentUser.get("email"),
                    phone: currentUser.get("phoneNumber")
                };
            } else if (!Utils.isEmptyObj(_this.props.guestInfoObj)) {
                billingDetails = {
                    name: _this.props.guestInfoObj.name,
                    email: _this.props.guestInfoObj.email,
                    phone: _this.props.guestInfoObj.phoneNumber
                };
            } else {

                // Need to verify
                Utils.hideSpinner();
                self.setState({
                    error: ERROR_MESSAGE
                    // isCardAdded    : false,
                    // isCardBeingAdd : false
                });
                return;
            }

            // call the stripe function to create the Payment Method
            stripe.createPaymentMethod({
                type: 'card',
                card: cardNumberElement,
                billing_details: billingDetails
            }).then(function (result) {
                if (result.error) {

                    self.setState({
                        error: result.error.message
                        // isCardAdded    : false,
                        // isCardBeingAdd : false
                    }, function () {
                        // Constants.scrollToTop('card-section');
                        // check user guest or not
                        // if guest user then logout
                        self.handleGuestUsers();
                    });
                } else {

                    // if addCardExistingUser is true then attachPaymentMethod
                    if (_this.state.addCardExistingUsers || _this.state.createGuestUserAccount) {

                        var paymentMethodId = result.paymentMethod.id;
                        self.attachPaymentMethod(paymentMethodId, billingDetails);
                    } else {
                        self.props.callBackParent(result);
                    }
                }
            });
        };

        _this.handleAddCards = function (e) {
            _this.setState({
                addCardExistingUsers: e.target.checked
            });
        };

        _this.state = {
            error: '',
            // isCardAdded          : false,
            // isCardBeingAdd       : false,
            addCardExistingUsers: false,
            createGuestUserAccount: false
        };
        return _this;
    }

    _createClass(AddCard, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            // refresh the current parse user data
            var currentUser = _parse2.default.User.current();
            if (!Utils.isEmptyObj(currentUser)) {
                Utils.refreshCurrentParseUser();
            }

            var getAddPaymentMethodRef = this.props.getAddPaymentMethodRef;

            getAddPaymentMethodRef && getAddPaymentMethodRef(this);
        }
    }, {
        key: 'componentDidMount',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var self, stripePublishableKey, isGuestUserAccAttach;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = this;
                                stripePublishableKey = _MainStore2.default.getStripePublishableKey();
                                // console.log("stripePublishableKey:"+stripePublishableKey);

                                // Initialize stripe data

                                _context.next = 4;
                                return self.initializeStripeData(stripePublishableKey);

                            case 4:

                                // Add stripe mount on the card form
                                cardNumberElement.mount('#card-number-element');
                                cardExpiryElement.mount('#card-expiry-element');
                                cardCvcElement.mount('#card-cvc-element');
                                cardPostalElement.mount('#card-postal-element');

                                // added the change event and card-error message
                                cardNumberElement.addEventListener('change', function (event) {
                                    self.handleCardElementChange(event);
                                });

                                cardExpiryElement.addEventListener('change', function (event) {
                                    self.handleCardElementChange(event);
                                });

                                cardCvcElement.addEventListener('change', function (event) {
                                    self.handleCardElementChange(event);
                                });

                                cardPostalElement.addEventListener('change', function (event) {
                                    self.handleCardElementChange(event);
                                });

                                // Check the user account need to be attach for customer
                                isGuestUserAccAttach = false;

                                if (!Utils.isEmptyObj(this.props.guestInfoObj)) {
                                    isGuestUserAccAttach = this.props.guestInfoObj.createGuestUserAccount;
                                }

                                this.setState({
                                    createGuestUserAccount: isGuestUserAccAttach
                                });

                            case 15:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function componentDidMount() {
                return _ref.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'handleCardElementChange',
        value: function handleCardElementChange(event) {
            var self = this;
            var displayError = "";
            if (event.error) {
                displayError = event.error.message;
            } else {
                displayError = '';
            }

            self.props.handleErrors(displayError, false);

            // self.setState({
            //     error: displayError
            // }, () => {
            //     Utils.hideSpinner();
            //     Constants.scrollToTop('card-section');
            // });
        }
    }, {
        key: 'initializeStripeData',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(publishableKey) {
                var elements, style;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:

                                // Initialize the Stripe and added Publishable API Key
                                stripe = Stripe(publishableKey);
                                elements = stripe.elements();
                                // configure the style of card form

                                style = {
                                    base: {
                                        color: "#2F2F2F",
                                        fontFamily: '"OpenSans", sans-serif',
                                        fontSmoothing: "antialiased",
                                        fontSize: "14px",
                                        "::placeholder": {
                                            color: "#aab7c4"
                                        }
                                    },
                                    invalid: {
                                        color: "#fa755a",
                                        iconColor: "#fa755a"
                                    }
                                };

                                // Initialize the card elements and updated the style

                                cardNumberElement = elements.create('cardNumber', {
                                    style: style
                                });
                                cardExpiryElement = elements.create('cardExpiry', {
                                    style: style
                                });
                                cardCvcElement = elements.create('cardCvc', {
                                    style: style
                                });
                                cardPostalElement = elements.create('postalCode', {
                                    style: style
                                });

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function initializeStripeData(_x) {
                return _ref2.apply(this, arguments);
            }

            return initializeStripeData;
        }()
    }, {
        key: 'placeOrder',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var self;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                self = this;
                                _context3.next = 3;
                                return new Promise(function (resolve) {
                                    return setTimeout(resolve, 3000);
                                });

                            case 3:
                                //place order
                                self.props.callBackParent({});

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function placeOrder() {
                return _ref3.apply(this, arguments);
            }

            return placeOrder;
        }()
    }, {
        key: 'refreshParseUser',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var _this2 = this;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _parse2.default.User.current().fetch().then(function (user) {

                                    // silent console log after update the current parse user
                                    console.log("user refreshed");
                                }, function (error) {
                                    // silent console log after update the current parse user
                                    console.log(JSON.stringify(error));

                                    //route to main-screen when there is error with user session.
                                    if (error.code === _parse2.default.Error.INVALID_SESSION_TOKEN) {

                                        _sweetalert2.default.fire({
                                            title: "User session expired.",
                                            text: SESSION_ERROR_MSG,
                                            icon: 'warning',
                                            showConfirmButton: false,
                                            showCancelButton: true,
                                            cancelButtonText: 'Close',
                                            customClass: {
                                                cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                                            },
                                            allowOutsideClick: false
                                        });

                                        var locId = _this2.props.locId;
                                        var router = _this2.props.history;
                                        Utils.logOut(router, locId, true);
                                    }
                                });

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function refreshParseUser() {
                return _ref4.apply(this, arguments);
            }

            return refreshParseUser;
        }()
    }, {
        key: 'handleGuestUsers',
        value: function handleGuestUsers() {

            Utils.hideSpinner();
            //scroll to error section
            Constants.scrollToTop('card-section');

            var currentUser = _parse2.default.User.current();

            if (!Utils.isEmptyObj(currentUser)) {
                // check if user accont is guest or existing user
                var locId = null;
                var history = this.props.history;
                var errorMsg = this.state.error;
                //signout guest users before creating guest account.
                if (!this.props.isLoggedInExistingUser) {
                    // console.log("logged out");
                    // signout guest users while creating account.
                    Utils.logOut(history, locId, false);
                    //set userSession false in cartScreen;
                    this.props.handleErrors(errorMsg, true);
                }
            }
        }
    }, {
        key: 'attachPaymentMethod',
        value: function attachPaymentMethod(paymentMethodId, billingDetails) {
            var _this3 = this;

            var self = this;
            var currentUser = _parse2.default.User.current();
            var userId = currentUser.id;
            var sessionToken = currentUser.getSessionToken();
            var cus_id = currentUser.get("cus_id") ? currentUser.get("cus_id") : "";

            var paymentObject = {
                "paymentMethodId": paymentMethodId,
                "customerId": cus_id,
                "customerDetails": billingDetails
            };

            _Api2.default.attachPaymentMethod(userId, sessionToken, paymentObject).then(function (response) {
                _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                            switch (_context5.prev = _context5.next) {
                                case 0:
                                    _Actions2.default.addPaymentMethod(response.data[0]);
                                    // refresh the current parse user data
                                    _context5.next = 3;
                                    return self.refreshParseUser();

                                case 3:
                                    //call place order
                                    _this3.placeOrder();

                                    // self.setState({
                                    //     // isCardAdded    : true,
                                    //     // isCardBeingAdd : false
                                    // });

                                case 4:
                                case 'end':
                                    return _context5.stop();
                            }
                        }
                    }, _callee5, _this3);
                }))();
            }, function (error) {
                // console.log("add-card : attachPaymentMethod : Error: " + JSON.stringify(error));
                var history = _this3.props.history;
                var locId = null;
                var guestAccount = _this3.state.createGuestUserAccount;

                var errorMsg = "";
                if (error && error.responseJSON.error.message) {
                    errorMsg = error.responseJSON.error.message;
                }

                self.setState({
                    error: errorMsg
                    // isCardAdded    : false,
                    // isCardBeingAdd : false
                }, function () {
                    Constants.scrollToTop('card-section');
                    Utils.hideSpinner();
                    if (guestAccount) {
                        Utils.logOut(history, locId, false);
                        self.props.handleErrors(errorMsg, true);
                    } else {
                        Utils.checkErrorIsInvalidSessionToken(error, history, locId, false);
                    }
                });
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps) {
                this.setState({
                    createGuestUserAccount: nextProps.guestInfoObj.createGuestUserAccount
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: '', id: 'accordion' },
                _react2.default.createElement(
                    'div',
                    { className: '' },
                    _react2.default.createElement(
                        'div',
                        { ref: 'collapseOne', id: 'collapseOne', className: this.props.parentClass == 'account' ? "panel-collapse collapse" : "panel-collapse" },
                        _react2.default.createElement(
                            'div',
                            { className: 'panel-card-body' },
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'cell example example3', id: 'example-3' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'fieldset' },
                                        !this.props.isLoggedInExistingUser ? _react2.default.createElement(
                                            'div',
                                            { className: 'card-details border-bottom' },
                                            _react2.default.createElement(
                                                'h4',
                                                { className: 'ml-5 f16-default header-location-default cart-header ft-14 cart-header' },
                                                'Enter your card details'
                                            )
                                        ) : null,
                                        _react2.default.createElement('div', { id: 'card-number-element',
                                            className: 'field empty ft-14 text-secondary-light' }),
                                        _react2.default.createElement('div', { id: 'card-expiry-element',
                                            className: 'field empty third-width ft-14 text-secondary-light' }),
                                        _react2.default.createElement('div', { id: 'card-cvc-element',
                                            className: 'field empty third-width ft-14 text-secondary-light' }),
                                        _react2.default.createElement('div', { id: 'card-postal-element',
                                            className: 'field empty third-width ft-14 text-secondary-light' })
                                    ),
                                    this.props.isLoggedInExistingUser ? _react2.default.createElement(
                                        'div',
                                        { className: 'fieldset addcard-container' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: "container-checkbox" },
                                            _react2.default.createElement('input', { type: 'checkbox',
                                                onChange: this.handleAddCards,
                                                checked: this.state.addCardExistingUsers,
                                                tabIndex: 25
                                            }),
                                            _react2.default.createElement('span', { className: 'checkmark' })
                                        ),
                                        _react2.default.createElement(
                                            'label',
                                            {
                                                className: 'account-check create-account' },
                                            _react2.default.createElement(
                                                'span',
                                                null,
                                                'Securely save this card for a faster checkout next time.'
                                            )
                                        ),
                                        _react2.default.createElement('span', { className: 'clearfix' })
                                    ) : null
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AddCard;
}(_react2.default.Component);

exports.default = AddCard;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/cart-left/AddCard.jsx
// module id = 712
// module chunks = 0